import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungVersFallListStatus: 'idle',
    loadMeldungVersFallListError: undefined as any,
    loadMeldungVersFallListLastArgs: undefined as any,
    loadMeldungVersFallStatus: 'idle',
    loadMeldungVersFallError: undefined as any,
    saveMeldungVersFallStatus: 'idle',
    saveMeldungVersFallError: undefined as any,
    deleteMeldungVersFallStatus: 'idle',
    deleteMeldungVersFallError: undefined as any,

    meldungVersFallList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungVersFallList = createAsyncThunk('meldungVersFallSlice/loadMeldungVersFallList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungVersFallSlice.loadMeldungVersFallListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldversfall/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungVersFallListStatus } = getState().meldungVersFallSlice
        return loadMeldungVersFallListStatus !== 'pending'
    }
})

export const loadMeldungVersFall = createAsyncThunk('meldungVersFallSlice/loadMeldungVersFall', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldversfall/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungVersFallStatus } = getState().meldungVersFallSlice
        return loadMeldungVersFallStatus !== 'pending'
    }
})

export const saveMeldungVersFall = createAsyncThunk('meldungVersFallSlice/saveMeldungVersFall', async ({ meldungVersFall }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/nurismeldversfall/${meldungVersFall.HDR_ID}/`,
        prepareData(meldungVersFall),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungVersFallStatus } = getState().meldungVersFallSlice
        return saveMeldungVersFallStatus !== 'pending'
    }
})

export const deleteMeldungVersFall = createAsyncThunk('meldungVersFallSlice/deleteMeldungVersFall', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldversfall/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungVersFallStatus } = getState().meldungVersFallSlice
        return deleteMeldungVersFallStatus !== 'pending'
    }
})

const MeldungVersFallSlice = createSlice({
    name: 'meldungVersFallSlice',
    initialState,
    reducers: {
        resetloadMeldungVersFallListError: (state) => {
            state.loadMeldungVersFallListError = undefined
        },
        resetloadMeldungVersFall: (state) => {
            state.formItem = undefined
            state.loadMeldungVersFallError = undefined
        },
        resetloadMeldungVersFallError: (state) => {
            state.loadMeldungVersFallError = undefined
        },
        resetsaveMeldungVersFall: (state) => {
            state.formItem = undefined
            state.saveMeldungVersFallError = undefined
        },
        resetsaveMeldungVersFallError: (state) => {
            state.saveMeldungVersFallError = undefined
        },
        resetdeleteMeldungVersFallError: (state) => {
            state.deleteMeldungVersFallError = undefined
        },
        removeFromMeldungVersFallListById: (state, action) => {
            state.meldungVersFallList = state.meldungVersFallList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungVersFallListByIds: (state, action) => {
            state.meldungVersFallList = state.meldungVersFallList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungVersFallList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungVersFallListStatus = 'preloaded'
            state.loadMeldungVersFallListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungVersFallList = []
            state.loadMeldungVersFallListStatus = 'idle'
            state.loadMeldungVersFallListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungVersFallList.pending, (state) => {
            state.loadMeldungVersFallListStatus = 'pending'
            state.loadMeldungVersFallListError = undefined
        })
        builder.addCase(loadMeldungVersFallList.fulfilled, (state, action) => {
            state.loadMeldungVersFallListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungVersFallListLastArgs = action.payload.args

            {
                state.meldungVersFallList = action.payload.data

            }
        })
        builder.addCase(loadMeldungVersFallList.rejected, (state, action) => {
            state.loadMeldungVersFallListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungVersFallListError = action.error.message
            } else {
                state.loadMeldungVersFallListError = action.payload
            }
        })

        builder.addCase(loadMeldungVersFall.pending, (state) => {
            state.loadMeldungVersFallStatus = 'pending'
            state.loadMeldungVersFallError = undefined
        })
        builder.addCase(loadMeldungVersFall.fulfilled, (state, action) => {
            state.loadMeldungVersFallStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungVersFallList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungVersFallList.push(newItem) }
                else { state.meldungVersFallList[i] = { ...state.meldungVersFallList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungVersFall.rejected, (state, action) => {
            state.loadMeldungVersFallStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungVersFallError = action.error.message
            } else {
                state.loadMeldungVersFallError = action.payload
            }
        })

        builder.addCase(saveMeldungVersFall.pending, (state) => {
            state.saveMeldungVersFallStatus = 'pending'
            state.saveMeldungVersFallError = undefined
        })
        builder.addCase(saveMeldungVersFall.fulfilled, (state, action) => {
            state.saveMeldungVersFallStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungVersFallList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungVersFallList.push(newItem) }
                else { state.meldungVersFallList[i] = { ...state.meldungVersFallList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungVersFall.rejected, (state, action) => {
            state.saveMeldungVersFallStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungVersFallError = action.error.message
            } else {
                state.saveMeldungVersFallError = action.payload
            }
        })

        builder.addCase(deleteMeldungVersFall.pending, (state) => {
            state.deleteMeldungVersFallStatus = 'pending'
            state.deleteMeldungVersFallError = undefined
        })
        builder.addCase(deleteMeldungVersFall.fulfilled, (state, action) => {
            state.deleteMeldungVersFallStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungVersFallList = state.meldungVersFallList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungVersFallList = state.meldungVersFallList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungVersFall.rejected, (state, action) => {
            state.deleteMeldungVersFallStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungVersFallError = action.error.message
            } else {
                state.deleteMeldungVersFallError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungVersFallListError,
    resetloadMeldungVersFall,
    resetloadMeldungVersFallError,
    resetsaveMeldungVersFall,
    resetsaveMeldungVersFallError,
    resetdeleteMeldungVersFallError,
    removeFromMeldungVersFallListById,
    removeFromMeldungVersFallListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungVersFallSlice.actions
export default MeldungVersFallSlice.reducer
